module.exports = __webpack_public_path__ + "img/skrill.d5a465cb.svg";